<template>
    <div>
        <TableBlock ref="tableData" :columns="cloumn" :action="action" :param="param" :navHeight="400" :autRequest="false">
            <div class="warp-deatlis">
               <div class="common-space-between common-items-center">
                    <div class="title">
                        <span>百仁吉智慧消防系统</span>
                        <span v-for="(item,index) in   this.$store.state.conText.accountTypeList" :key="index">
                        <span v-if="item.val == param.belongToType">({{item.title}})</span> 
                        </span>  
                    </div>
                    <el-button class="btn-heigth" type="danger"  icon="el-icon-refresh" :size="this.$store.state.btnSize"  @click="returnBtn">返回</el-button>
               </div> 

                <div class="warp-block">
                    <div class="block" v-for="(item,index) in listTitle" :key="index">{{item.title}}{{item.value}}</div>
                </div> 
            </div>
            <div class="common-space-between">
                <div class="common-items-center">
                    <InputBlock title="账户信息" :showBlock="false" :width="150">
                        <el-input v-model="param.person" :size="this.$store.state.btnSize" placeholder="请输入操作人"></el-input>
                    </InputBlock>
                    <InputBlock title="支付方式" :width="150">
                        <el-select v-model="param.payType" placeholder="请选择支付方式"  :size="this.$store.state.btnSize">
                            <el-option v-for="item in this.$store.state.conText.payListType" :key="item.val" :label="item.title" :value="item.val" />
                        </el-select>
                    </InputBlock>
                    <InputBlock title="充值类型" :width="150">
                        <el-select v-model="param.rechargeType" placeholder="请选择充值方式"  :size="this.$store.state.btnSize">
                            <el-option v-for="item in this.$store.state.conText.searchrechargeListType" :key="item.val" :label="item.title" :value="item.val" />
                        </el-select>
                    </InputBlock>
                    <Month title="充值时间" ref="mouth" :width="150" @getDate="getDate"></Month>
                    <el-button class="btn-heigth" type="primary" icon="el-icon-search" :size="this.$store.state.btnSize"   @click="searchBtn">搜索</el-button>
                    <el-button class="btn-heigth" type="danger"  icon="el-icon-refresh" :size="this.$store.state.btnSize"  @click="resetBtn">重置</el-button>
                    <el-button class="btn-heigth" type="success"  icon="el-icon-plus" :size="this.$store.state.btnSize"  @click="TopUpBtn">充值</el-button>
                </div>
                <div>
                    <el-button class="btn-heigth" type="primary" icon="el-icon-download" :size="this.$store.state.btnSize"   @click="exportBtn">导出</el-button>
                </div>
            </div>
        </TableBlock>
        <TopUp ref="TopUp"  @resetBtn="resetData" ></TopUp>
    </div>
</template>
<script>
import { postFun,httpImg,exportFun } from '@/utils/httpFun'
import {url,api,operate} from '@/utils/config'
import { columns } from './index.js'
import Month from '@/components/component-block/block-month.vue'
import TopUp from './../recharge/module-block/TopUp.vue'
export default {
    components: {
        Month: Month,
        TopUp:TopUp
    },
    data() {
        return {
            cloumn: [],
            action: operate.GETPAGEACCOUNTDE,
            belongToType:"",
            listTitle:[
                    {title:"所属省/市/区县：",value:""},
                    {title:"详细地址：",value:""},
                    {title:"账户ID：",value:""},
                    {title:"账户充值总余额（元）：",value:""},
                    {title:"账户充值余额（元）",value:""},
                    {title:"创建时间：",value:""},
                    {title:"赠送总金额（元）：",value:""},
                    {title:"赠送余额（元）：",value:""},
                    {title:"钱包余额（元）：",value:""},
            ],
            param: {
                accountRechargeType:"",
                payType:"",
                rechargeType:"",
                person:"",
                belongToId:"",
                belongToType:"",
                startTime:null,
                endTime:null
            }
        };
    },
    created() {
        this.param.belongToId=this.$route.query.belongToId
        this.param.belongToType=this.$route.query.belongToType

        console.log('==============',this.$route)

        this.cloumn = columns(this);
        this.getInfo()
    },
    mounted() {

    },
    methods: {
        getInfo(){
            this.belongToType = this.$route.query.belongToType
            let parms = {
                belongToId:this.$route.query.belongToId,
                belongToType:this.$route.query.belongToType,
            }
            postFun(api.Operate+"/financeManager/getAccountDetails",parms,res=>{
                this.listTitle = [
                    {title:"省市区县：",value:res.data.areaAddress},
                    {title:"详细地址：",value:res.data.address},
                    {title:"账户ID：",value:res.data.belongToId},
                    {title:"账户充值总余额：",value:res.data.rechargeTotalBalance+"元"},
                    {title:"账户充值余额：",value:res.data.rechargeBalance+"元"},
                    
                    {title:"赠送总金额：",value:res.data.giveTotalBalance+"元"},
                    {title:"赠送余额：",value:res.data.giveBalance+"元"},
                    {title:"钱包余额：",value:res.data.walletBalance+"元"},
                    {title:"创建时间：",value:res.data.createTime},
                ]
                this.action = operate.GETPAGEACCOUNTDE
                this.$nextTick(res=>{
                    this.searchBtn()
                })
                
            })
        },

        //查询
        searchBtn(){
           this.$refs.tableData.getDatas()
        },
        //重置
        resetBtn(){
            this.param = {
                accountRechargeType:"",
                rechargeType:"",
                person:"",
                startTime:null,
                endTime:null
            }
            this.$refs.mouth.clear()
            this.$refs.tableData.resetHttp()  
        },
        
        TopUpBtn(){
            this.$refs.TopUp.openBtn({belongToId:this.$route.query.belongToId,belongToType:this.$route.query.belongToType})
        },
        
        //刷新
        resetData(){
            this.$refs.tableData.getDatas()
            this.getInfo()
        },

        //获取时间
        getDate(ev) {
            this.param.startExpirationTime = ev.startDate+" 00:00:00"
            this.param.entExpirationTime = ev.endDate+" 23:59:59"
        },
        //导出
        exportBtn(){
            exportFun(operate.EXPORSEVER,this.param,"服务费充值记录")
        },
        //返回
        returnBtn(){
            this.$router.replace({
            path:"Recharge",
            query:{}
          })
        },

        //导出
        exportBtn(){
            exportFun(api.Operate+"/financeManager/exportAccountRechargeRecord",this.param,"账户充值管理")
        }
    }
}
</script>
  
<style lang="scss" scoped>
  .title{
    color:#606266;
    margin-bottom: 15px;
  }
  .warp-block{
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 10px;
    .block{
        margin-bottom: 10px;
        width: 33%;
        font-size: 14px;
        color:#606266;
    }
  }
</style>